/*
  品牌客製化的預設值與共用工具
  放在 src/context/brandingDefaults.js
*/
import defaultLoginImage from "../image/login.jpg";

// 系統預設（公司沒有設定時使用）
export const DEFAULT_TITLE = "IoT 監測控制系統";
export const DEFAULT_LOGIN_IMAGE = defaultLoginImage;
export const DEFAULT_FAVICON = `${process.env.PUBLIC_URL || ""}/logo.svg`;

// localStorage keys
export const THEME_STORAGE_KEY = "iot3_theme_preference"; // 只有網管會寫入
export const BRANDING_CACHE_KEY = "iot3_branding_cache"; // 避免重新整理時閃一下預設品牌

// 未登入 / 無公司時的品牌：theme_locked = false 代表主題交給 localStorage 決定
export const DEFAULT_BRANDING = {
  slug: null,
  title: null,
  theme: null,
  theme_locked: false,
  logo_url: null,
  login_image_url: null,
  favicon_url: null,
};

export function normalizeBranding(raw) {
  if (!raw || typeof raw !== "object") {
    return { ...DEFAULT_BRANDING };
  }
  return {
    slug: raw.slug || null,
    title: raw.title || null,
    theme: raw.theme || null,
    theme_locked: Boolean(raw.theme_locked),
    logo_url: raw.logo_url || null,
    login_image_url: raw.login_image_url || null,
    favicon_url: raw.favicon_url || null,
  };
}

/*
  後端回傳的是 /assets/images/branding/xxx.png（與前端同網域）。
  若開發環境前後端不同網域，可設定 REACT_APP_ASSET_BASE 補上前綴。
*/
export function resolveAssetUrl(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  const base = process.env.REACT_APP_ASSET_BASE;
  if (base && url.startsWith("/")) {
    return `${base.replace(/\/$/, "")}${url}`;
  }
  return url;
}

export function readCachedBranding() {
  try {
    const raw = localStorage.getItem(BRANDING_CACHE_KEY);
    return raw ? normalizeBranding(JSON.parse(raw)) : null;
  } catch (e) {
    return null;
  }
}

export function writeCachedBranding(branding) {
  try {
    localStorage.setItem(BRANDING_CACHE_KEY, JSON.stringify(branding));
  } catch (e) {
    /* 隱私模式等情況可忽略 */
  }
}

export function clearCachedBranding() {
  try {
    localStorage.removeItem(BRANDING_CACHE_KEY);
  } catch (e) {
    /* ignore */
  }
}